import { createSelector } from 'reselect';

const getAbTesterState = (state) => state.abTester;

const wasQueriedSuccesfully = createSelector(
  getAbTesterState,
  ({ error, wasQueried }) => wasQueried && error === undefined,
);

export { wasQueriedSuccesfully };
